import React from 'react'

const SvgBirthdayCakeFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M4 14a2 2 0 012-2h12a2 2 0 012 2v1.319s-.327.161-.991.161c-1.528 0-1.458-.978-3.02-.978-1.505 0-1.47.978-2.974.978-1.586 0-1.516-.978-3.02-.978s-1.423.982-3.009.978C5.53 15.477 6 14.502 4 14.502V14zM10 15.5c1.525 0 1.467 1 3 1s1.509-1 2.992-1 1.459 1 3.009 1c.65 0 .999-.141.999-.141v3.64a2 2 0 01-2 2H6a2 2 0 01-2-2v-4.49c2.008-.009 1.458.991 3 .991 1.475 0 1.558-1 3-1zM11 7h2v4h-2V7zM13.5 4.4c0 .884-.671 1.6-1.5 1.6-.828 0-1.5-.716-1.5-1.6C10.5 3.516 12 2 12 2s1.5 1.516 1.5 2.4z' />
  </svg>
)

export default SvgBirthdayCakeFilled
